export default {"src":"/_next/static/media/loading.a619263b.svg","height":200,"width":200};